import React from 'react';
import Menubar from '../../components/Menubar';
import './Jshome.css';
import './Mobilejshome.css';
import Play from './play.svg';
import Footer from '../../components/Footer.js';
import Htmlcard from '../../assets/HTML basics card.svg';
import Csscard from '../../assets/CSS basics card.svg';
import { Link } from 'react-router-dom';


const Csshome = () => {
    return (
      <div className='Htmlpagecontainer'>
        <div className='men'>
          <Menubar />
      </div>

        <div className='jshero' id='jshero'>
        <div className='coursehero'>
            <div className='title'>
                <h1>Javascript Basics</h1>
                <p>Javascript allows you to create interactive and dynamic content on websites.</p>
            </div>
            <div className='titleintro'>
                <p>Difficulty level: Beginner</p>
                <p>Prerequisites : Learn HTML and CSS before learning javascript.</p>
            </div>
        </div>
        </div>

        <div className='takeaway'>
            <h3>Take Away Skills</h3>
            <ul>
                <li>You’ll learn the basic syntax and structure of the Javascript language, including how to write statements, use variables and create loops and conditional statements.</li>
                <li>You’ll learn how to use Javascript to manipulate and interact with elements in an HTML document.</li>
                <li>You’ll learn how to use functions and objects to organize and structure your code, as well as how to use built-in objects like arrays and strings.</li>
            </ul>
        </div>

        <div className='whatyoulearn'>
            <h3>What You’ll Learn</h3>
            <div className='module'>
                <h4>Module 1 : Get Started</h4>
                <p>In this module you will get foundational understanding about using Javascript.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>Introduction</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Development Tools</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Introduction to chrome dev tools</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Add JS to web page : Inline</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Add JS to web page : Internal</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>Add JS to head or body</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Our first Javascript code</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Javascript output</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>Variables</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>10</p>
                        <p>Data types</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>11</p>
                        <p>Expression</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>12</p>
                        <p>Arithmetic operators</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>13</p>
                        <p>Type conversion and Typeof</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>14</p>
                        <p>String operators</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>15</p>
                        <p>Boolean</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 2 : Control Structures</h4>
                <p>Learn conditional statements, loops and logical operators.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>If and if else statements</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Comparison Operators</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Logical Operators + Ternaries</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>switch</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>for</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>while</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 3 : Functions & Data Structures</h4>
                <p>This module will help in understanding how to use functions and objects to organize and structure your code.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p> What is a function?</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Function Declaration</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Calling a function</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>More ways to make functions</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Function parameters</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>Scope : Global and Local</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Function hoisting</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Variables : const keyword</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>Function Experssion</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>10</p>
                        <p>Anonymous Function</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>11</p>
                        <p>Constructor function</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>12</p>
                        <p>Nested functions and closures</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>13</p>
                        <p>What is array?</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>14</p>
                        <p>Create an Array</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>  
                    <div className='seq'>
                        <p>15</p>
                        <p>Access & change Array elements</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div> 
                    <div className='seq'>
                        <p>16</p>
                        <p>Add a new element to array</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div> 
                    <div className='seq'>
                        <p>17</p>
                        <p>Objects</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>18</p>
                        <p>Creating new objects</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>19</p>
                        <p>Accessing object properties</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>20</p>
                        <p>Object Methods</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>21</p>
                        <p>this Keyword</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>	
                </div>
            </div>
            <div className='module'>
                <h4>Module 4 : Document Object Model & Events</h4>
                <p>Learn about manipulating HTML document and interact with elements such as changing the content or style of an element.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>What is DOM ?</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>DOM tree</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Selecting HTML Elements</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Changing HTML Elements</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Modifying CSS</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>What are Events ?</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Mouse click</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Event Listner</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>Web page loading</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>10</p>
                        <p>Form submission</p>
                        <Link to = "/jslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
        </div>


        <div className='whatnext'>
            <h3>What Next</h3>
            
            <div className='whatnextgrid'>
                <div className='whatnextcol'>
                    <p>1</p>
                    <Link to='/html'><img src={Htmlcard} /></Link>
                </div>
                <div className='whatnextcol'>
                    <p>2</p>
                    <Link to='/css'><img src={Csscard} /></Link>
                </div>
            </div>       
        </div>

        <div className='faq'>
        <h1>Frequently Asked Questions</h1>
        <div className='faqgrid'>
          <div className='faqcol'>
            <p>Q. Why should I learn Javascript?</p>
            <p>A. It is a fundamental technology used to build a web page or web application.</p>
          </div>
          <div className='faqcol'>
            <p>Q. Is hard to learn Javascript?</p>
            <p>A. Javascript is relatively easy to learn as compared to othe programming languages. With practice you can master it.</p>
          </div>
          <div className='faqcol'>
            <p>Q. What is the recommended way to learn Javascript?</p>
            <p>A. Read lessons and code along. Read the Javascript 
            documentation. Build some website features and practice a lot. </p>
          </div>
        </div>
      </div>

      <Footer />

      </div>
      
    );
  };
  
  export default Csshome;